import React, { useContext, useEffect, useState } from 'react';
import useHTTP from  '@/components/hooks/useHTTP';
import { permissions, PlannerSettingsContext } from '@/context/PlannerSettingsContext';

const usePlannerSettings = (id = 0) => {

    const [loading, setLoading] = useState<boolean>(null)

    const {setPermissions} = useContext(PlannerSettingsContext);

    const { get } = useHTTP();

    // Permissions
    useEffect(() => {

        const perm:permissions = {
            canAddCalendar:false,
            canDeleteCalendar:false,
            canManageCalendar:false,
            canViewCalendarSettings:false
        }

        // Can add?
        setLoading(true)

        get(`planner/calendar/role/me`).then(({data}) => {

            perm.canAddCalendar = data.canAddCalendar;

        }).finally(() => {

            if (!id){
                setLoading(false)
            }
        })

        // Can edit?
        if (id){

            setLoading(true)

            get(`planner/calendar/${id}/role/me`).then(({data}) => {

                perm.canManageCalendar = data.canManageCalendar;
                perm.canViewCalendarSettings = data.canViewCalendarSettings;
                perm.canDeleteCalendar = data.canDeleteCalendar;

            }).finally(() => {
                setLoading(false)
            })
        }

        setPermissions(perm)

    }, [id])

    return {loadingPerm:loading}

};

export default usePlannerSettings;

